<template>
  <div>
    <section>
      <div class="inner service-search row5">
        <div class="service-search__left">
          <div class="searchTitleBox">
            <h1 class="boardTitle">제품 · 서비스 검색</h1>

            <div>
              <router-link :to="{ path: '/', hash: '#section0' }"
                >고령친화제품·서비스 화면 이동</router-link
              >
              <router-link to="/user/searchHistory" v-if="isUser"
                >나의 검색 이력 화면으로 이동</router-link
              >
            </div>
          </div>
          <div>
            <div class="serviceSearchform">
              <p>
                고객님이 찾으시는 제품과 서비스를 검색해주세요.
              </p>
              <div class="searchBox">
                <input
                  type="text"
                  v-model="searchText"
                  @keyup.enter="searchDatas"
                />
                <button @click="searchDatas"></button>
              </div>
            </div>

            <div class="serviceTabMenu">
              <ul>
                <li
                  :class="[
                    { active: type === 'PRODUCT' },
                    { serviceTabMenuItem: true },
                  ]"
                  @click="changeType('PRODUCT')"
                >
                  제품
                </li>
                <li
                  :class="[
                    { active: type === 'SERVICE' },
                    { serviceTabMenuItem: true },
                  ]"
                  @click="changeType('SERVICE')"
                >
                  서비스
                </li>
              </ul>
            </div>

            <div class="searchCondition">
              <!-- 조건 1 : 산업별 -->
              <section class="conditionCon">
                <div class="title">
                  <p v-if="type === 'PRODUCT'">제품 산업 분류(1차)</p>
                  <p v-if="type === 'SERVICE'">서비스 산업 분류(1차)</p>

                  <div class="allSelectBox">
                    <div class="checkBoxItem">
                      <input
                        type="checkbox"
                        id="allSelectInput"
                        v-model="allSelect"
                        @change="onChangeAllSelect"
                      />
                      <label for="allSelectInput">
                        전체선택
                      </label>
                    </div>
                  </div>
                </div>
                <div class="conditionCategory">
                  <div
                    v-for="(item, index) in firstCategory"
                    :key="index"
                    @click="addFirstCategory(item.IDX)"
                    :class="[
                      {
                        selected: selectedFirstCategory.indexOf(item.IDX) > -1,
                      },
                      { conditionCategoryItem: true },
                    ]"
                  >
                    <div class="imgBox">
                      <img
                        v-bind:src="
                          require('../../assets/images/cmmnMain/CategoryStep/icon/' +
                            item.IMAGE)
                        "
                        v-bind:alt="item.IMAGE"
                      />
                    </div>
                    <div class="itemTitle">
                      <p>
                        {{ item.NAME }}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <!-- 조건 2 : 종류별 -->
              <section class="conditionCon">
                <div class="title">
                  <p v-if="type === 'PRODUCT'">제품 종류(2차)</p>
                  <p v-if="type === 'SERVICE'">서비스 종류(2차)</p>
                </div>
                <div class="conditionType">
                  <div class="typeTop">
                    <p @click="selectTotalCategory">
                      전체
                      <span> ({{ wholeCnt }}) </span>
                    </p>
                  </div>
                  <div class="typeBody">
                    <div
                      v-for="(category, index) in categories"
                      :key="index"
                      class="typeBodyCon"
                    >
                      <div class="title">
                        <p>
                          {{ category.NAME }}
                        </p>
                      </div>
                      <div class="typeBodyItem">
                        <div
                          v-for="(item, itemIndex) in category.ITEMS"
                          :key="itemIndex"
                          class="checkBoxItem"
                          v-show="item.ITEM_COUNT > 0"
                        >
                          <input
                            type="checkbox"
                            :id="'categoryCheckbox' + index + '_' + itemIndex"
                            :value="item.NAME"
                            v-model="selectedSecondCategory"
                          />
                          <label
                            :for="'categoryCheckbox' + index + '_' + itemIndex"
                          >
                            {{ item.NAME }} (<span> {{ item.ITEM_COUNT }} </span
                            >)
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div class="searchConfirmBtnBox">
              <button @click="searchDetailDatas">
                적용
              </button>
            </div>

            <div v-if="listViewYn" class="searchResultTxtBox">
              <p>
                검색 결과
              </p>
            </div>

            <div v-if="listViewYn" class="searchResultCon">
              <div class="searchResultTitle flexBox">
                <p>
                  검색결과 : 총
                  <span>
                    {{ totalCnt }}
                  </span>
                  건
                </p>
                <div class="surveySelectBox">
                  <b-form-select
                    v-model="sorting"
                    :options="sortingOptions"
                    @change="searchDetailDatas"
                  ></b-form-select>
                </div>
              </div>
              <hr />
              <div v-if="type === 'SERVICE'" class="searchResultBody">
                <router-link
                  :to="
                    '/serviceDetail/' +
                      service.CATEGORY_IDX +
                      '/' +
                      service.SERVICE_IDX
                  "
                  v-for="(service, index) in items"
                  :key="index"
                >
                  <div class="searchResultItem">
                    <div class="imgBox">
                      <img :src="service.MAIN_FILE" alt="" />
                    </div>
                    <div class="title">
                      <p>
                        {{ service.CATEGORY_NAME }}
                      </p>
                    </div>
                    <div class="subContent">
                      <table>
                        <tbody>
                          <tr>
                            <th>생활 구분</th>
                            <td>{{ service.LIFE }}</td>
                          </tr>
                          <tr>
                            <th>업체명</th>
                            <td>{{ service.COMPANY }}</td>
                          </tr>
                          <tr>
                            <th>서비스명</th>
                            <td>{{ service.NAME }}</td>
                          </tr>
                          <tr>
                            <th>사용제안대상</th>
                            <td>
                              <p>
                                {{ service.TARGET }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </router-link>
              </div>
              <div v-if="type === 'PRODUCT'" class="searchResultBody">
                <router-link
                  :to="
                    '/productDetail/' +
                      product.CATEGORY_IDX +
                      '/' +
                      product.PRODUCT_IDX
                  "
                  v-for="(product, index) in items"
                  :key="index"
                >
                  <div class="searchResultItem">
                    <div class="imgBox">
                      <img :src="product.MAIN_FILE" alt="" />
                    </div>
                    <div class="title">
                      <p>
                        {{ product.CATEGORY_NAME }}
                      </p>
                    </div>
                    <div class="subContent">
                      <table>
                        <tbody>
                          <tr>
                            <th>제조구분</th>
                            <td>{{ product.MANUFACTURE_STR }}</td>
                          </tr>
                          <tr>
                            <th>업체명</th>
                            <td>{{ product.COMPANY }}</td>
                          </tr>
                          <tr>
                            <th>제품명</th>
                            <td>{{ product.NAME }}</td>
                          </tr>
                          <tr>
                            <th>사용제안공간</th>
                            <td>
                              <p>
                                {{ product.PLACE_NAME }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div v-if="listViewYn" class="tableContainer">
              <div class="sampleTemplate">
                <paginate
                  v-model="currentPage"
                  :page-count="navCnt"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'‹'"
                  :next-text="'›'"
                  :container-class="'pagination b-pagination newPagination'"
                >
                </paginate>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="service-search__right">
          <div class="serviceTabMenu serviceTabMenu--right mt-4">
            <ul>
              <li
                @click="activeRightTab = 1"
                class="serviceTabMenuItem"
                :class="{ active: activeRightTab == 1 }"
              >
                최근 본 제품
              </li>
              <li
                @click="activeRightTab = 2"
                class="serviceTabMenuItem"
                :class="{ active: activeRightTab == 2 }"
              >
                최근 본 서비스
              </li>
            </ul>
          </div>

          <div class="vs-service">
            <div class="alignC">
              <i class="ic ic--arrow-top" @click="showPrev"></i>
            </div>

            <VueSlickCarousel
              v-bind="settings"
              :key="carouselKey"
              ref="carousel"
            >
              <div class="vs-service__item" v-for="item in 10" :key="item">
                <div class="item-product">
                  <i class="ic ic--delete"></i>
                  <div class="imgBox">
                    <img
                      :src="require('../../assets/images/product/image_1.png')"
                      alt=""
                    />
                  </div>
                  <div>
                    이동산업/교통산업-제품 (이동기기(지팡이; 일반보행기; 보행차;
                    보행보조차; 실내휠체어; 이동기기 리프트; 단차해소
                  </div>
                </div>
              </div>
            </VueSlickCarousel>
            <div class="alignC">
              <i class="ic ic--arrow-bottom" @click="showNext"></i>
            </div>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "@/axios/axios";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "ServiceSearch",
  components: {
    VueSlickCarousel,
  },
  computed: {
    ...mapGetters("auth", ["isAuth", "getUser"]),
    isUser() {
      if (
        this.isAuth == true &&
        this.getUser != null &&
        this.getUser.roleName === this.$role.USER
      )
        return true;
      else return false;
    },
    navCnt: function() {
      if (this.totalCnt % this.perPage == 0)
        return this.totalCnt / this.perPage;
      else return Math.floor(this.totalCnt / this.perPage) + 1;
    },
  },
  data() {
    return {
      settings: {
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
      },
      carouselKey: 1,
      activeRightTab: 1,
      allSelect: false,
      selected: "first",
      firstCategory: [],
      selectedFirstCategory: [],
      categories: [],
      categoryList: [],
      selectedSecondCategory: [],
      selectedCurrentSecondCategory: [],
      items: null,
      searchText: "",
      perPage: 9,
      currentPage: 1,
      totalCnt: 0,
      sortBy: "IDX",
      sortDesc: false,
      type: "PRODUCT",
      listViewYn: false,
      wholeCnt: 0,
      isTotalSelected: true,
      sorting: "",
      sortingOptions: [
        { value: "", text: "선 택" },
        { value: "PRICE_ASC", text: "낮은가격순" },
        { value: "PRICE_DESC", text: "높은가격순" },
        { value: "NAME_ASC", text: "이름 오름차순" },
        { value: "NAME_DESC", text: "이름 내림차순" },
      ],
    };
  },
  watch: {
    selectedFirstCategory(value) {
      if (value.length <= 0) {
        this.items = [];
        this.totalCnt = 0;
        this.sortBy = "IDX";
        this.sortDesc = false;
        this.listViewYn = false;
        this.categories = [];
        this.selectedSecondCategory = [];
        this.wholeCnt = 0;
        return;
      }

      this.updateSecondCategory();
    },
  },
  mounted() {
    this.requestIndustryList(this.type)
      .then((response) => {
        this.firstCategory = response.data;
      })
      .catch(() => {
        this.$alert("알림", "산업별 1차 데이터를 가져올 수 없습니다.");
      });
  },
  methods: {
    ...mapActions("category", [
      "requestIndustryList",
      "requestCategoryGroupByIndustryIdxList",
    ]),
    changeType(value) {
      if (value === this.type) return;

      this.type = value;

      this.allSelect = false;
      this.firstCategory = [];
      this.selectedFirstCategory = [];

      this.requestIndustryList(this.type)
        .then((response) => {
          this.firstCategory = response.data;
        })
        .catch(() => {
          this.$alert("알림", "산업별 1차 데이터를 가져올 수 없습니다.");
        });
    },
    addFirstCategory(idx) {
      /* this.selectedSecondCategory = []; */
      this.selectedCurrentSecondCategory = [];
      var index = this.selectedFirstCategory.indexOf(idx);
      if (index > -1) {
        this.selectedFirstCategory.splice(index, 1);
      } else {
        this.selectedFirstCategory.push(idx);
      }
    },
    searchDatas() {
      if (this.searchText === "") {
        this.$alert("알림", "키워드를 입력해주세요.");
        return;
      }
      this.$router.push({
        path: "/serviceSearchResult",
        query: { searchText: this.searchText },
      });
    },
    resetSearch() {
      this.state = "";

      let path = `/serviceSearch`;
      if (this.$route.fullPath !== path) {
        this.$router.push({ path: "/serviceSearch" });
      }

      this.updateSecondCategory();
    },
    clickCallback(pageNum) {
      this.currentPage = pageNum;
      this.updateSecondCategory();
      this.searchDetailDatas();
    },
    updateSecondCategory() {
      this.requestCategoryGroupByIndustryIdxList({
        industryIdxList: this.selectedFirstCategory,
        type: this.type,
      })
        .then((response) => {
          let previeousCategories = [];
          for (let i = 0; i < this.categories.length; i++) {
            let category = this.categories[i];
            for (let j = 0; j < category.ITEMS.length; j++) {
              let item = category.ITEMS[j];
              previeousCategories.push(item.NAME);
            }
          }

          this.categories = response.data;
          let categoryNameList = [];
          this.wholeCnt = 0;

          for (let i = 0; i < this.categories.length; i++) {
            let category = this.categories[i];
            for (let j = 0; j < category.ITEMS.length; j++) {
              let item = category.ITEMS[j];

              categoryNameList.push(item.NAME);
              this.wholeCnt += item.ITEM_COUNT;
            }
          }

          if (categoryNameList == null) this.selectedSecondCategory = null;

          for (let i = 0; i < previeousCategories.length; i++) {
            let categoryIndex = categoryNameList.indexOf(
              previeousCategories[i]
            );
            if (categoryIndex < 0) {
              let index = this.selectedSecondCategory.indexOf(
                previeousCategories[i]
              );
              if (index > -1) {
                this.selectedSecondCategory.splice(index, 1);
              }
            }
          }
        })
        .catch(() => {
          this.$alert("알림", "데이터를 가져올 수 없습니다.");
        });
    },
    searchDetailDatas() {
      this.selectedCurrentSecondCategory = [];
      this.selectedCurrentSecondCategory = this.selectedSecondCategory;

      var categories = "";
      for (var i = 0; i < this.selectedCurrentSecondCategory.length; i++) {
        categories += this.selectedCurrentSecondCategory[i] + "|";
      }

      if (!categories) {
        this.items = [];
        this.totalCnt = 0;
        this.sortBy = "IDX";
        this.sortDesc = false;
        return;
      }

      var url = "";
      if (this.type === "PRODUCT") {
        url = "/api/product/getList";
      } else if (this.type === "SERVICE") {
        url = "/api/service/getList";
      } else {
        return;
      }

      if (this.sorting === "PRICE_ASC") {
        this.sortBy = "PRICE";
        this.sortDesc = false;
      } else if (this.sorting === "PRICE_DESC") {
        this.sortBy = "PRICE";
        this.sortDesc = true;
      } else if (this.sorting === "NAME_ASC") {
        this.sortBy = "NAME";
        this.sortDesc = false;
      } else if (this.sorting === "NAME_DESC") {
        this.sortBy = "NAME";
        this.sortDesc = true;
      } else {
        this.sortBy = "IDX";
        this.sortDesc = false;
      }

      var res = axios
        .post(url, null, {
          params: {
            searchText: "",
            currentPage: this.currentPage,
            perPage: this.perPage,
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
            categories: categories,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log("error: " + error);
          return Promise.reject(error);
        });

      res.then((response) => {
        this.items = response.data.items;
        this.totalCnt = response.data.totalCnt;
        this.listViewYn = true;

        if (this.items == null) {
          this.items = [];
          this.totalCnt = 0;
          this.listViewYn = false;
        }
      });
    },
    selectTotalCategory() {
      let categoryIdxs = [];
      for (let i = 0; i < this.categories.length; i++) {
        for (let j = 0; j < this.categories[i].ITEMS.length; j++) {
          if (this.categories[i].ITEMS[j].ITEM_COUNT > 0) {
            categoryIdxs.push(this.categories[i].ITEMS[j].NAME);
          }
        }
      }

      let isTotalSelected = true;
      if (this.selectedSecondCategory.length == 0) {
        isTotalSelected = false;
      }

      for (let i = 0; i < categoryIdxs.length; i++) {
        if (this.selectedSecondCategory.indexOf(categoryIdxs[i]) < 0) {
          isTotalSelected = false;
          break;
        }
      }

      this.selectedSecondCategory = [];
      if (!isTotalSelected) {
        this.selectedSecondCategory = categoryIdxs;
      }
    },
    onChangeAllSelect(event) {
      const checked = event.target.checked;

      if (checked) {
        for (let i in this.firstCategory) {
          this.selectedFirstCategory.push(this.firstCategory[i].IDX);
        }
      } else {
        this.selectedFirstCategory = [];
      }
    },
    forceRerender() {
      this.carouselKey += 1;
    },
    showNext() {
      this.$refs.carousel.next();
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
  },
};
</script>

<style scoped>
a {
  color: #272727;
}
h3 {
  margin: 0 0 16px 0;
}
.aside-fixed-con {
  position: fixed;
  right: 150px;
  top: 300px;
  border: 1px solid #000;
  padding: 1em;
}
.service-search__left {
  width: 100%;

}

</style>

<!-- <style scoped lang="scss">
  .service-search {
    display: flex;
    @include e("left") {
      width: calc(100%);
      padding-right: 0px;
    }

    @include e("right") {
      width: 240px;
    }
  }

</style> -->
